import React, { useState } from "react";
import qrImg from "./Lixil Deisgn/whatsAppBar.3a1067650ba1054b7a1f.png";
import waLogo from "./Lixil Deisgn/whatsAppLogo.dc11f99f75b31aa1950e.png";
import DelayedService from "./Lixil Deisgn/Delayed.png";
import ProductPerformace from "./Lixil Deisgn/Product Performance.png";
import Technician from "./Lixil Deisgn/Technician Related.png";
import Difficulty from "./Lixil Deisgn/Difficulty in complaint registration.png";
import QuickService from "./Lixil Deisgn/quick_service.png";
import axios from "axios";

const feedbackOptions = [
  { key: "Delayed Service", label: "Delayed Service", img: DelayedService },
  {
    key: "Product Performance",
    label: "Product Performance",
    img: ProductPerformace,
  },
  { key: "Technician Related", label: "Technician Related", img: Technician },
  {
    key: "Difficulty in Complaint Registration",
    label: "Difficulty in Complaint Registration",
    img: Difficulty,
  },
];

const POSITIVE_FEEDBACK_OPTIONS = [
  { key: "Quick Service", label: "Quick Service", img: QuickService },
  {
    key: "Product Performance",
    label: "Product Performance",
    img: ProductPerformace,
  },
  { key: "Technician Behavior", label: "Technician Behavior", img: Technician },
  {
    key: "Ease of Complaint registration",
    label: "Ease of Complaint registration",
    img: Difficulty,
  },
];

const NEGATIVE_FEEDBACK_OPTIONS = [
  { key: "Delayed Service", label: "Delayed Service", img: DelayedService },
  {
    key: "Product Performance",
    label: "Product Performance",
    img: ProductPerformace,
  },
  { key: "Technician Related", label: "Technician Related", img: Technician },
  {
    key: "Difficulty in Complaint Registration",
    label: "Difficulty in Complaint Registration",
    img: Difficulty,
  },
];

const ESCALATION_REASONS = [
  "Dealer Related",
  "Wrong Closure",
  "Technician Behaviour Related",
  "Technical Skill Related",
  "Spare Delay",
  "Repair Delay",
  "Product Quality",
];

function EscalateModal({ onClose }) {
  const [reason, setReason] = useState(ESCALATION_REASONS[0]);
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successPopup, setSuccessPopup] = useState(false);
  const handleSubmit = async () => {
    // ✅ Prevent double triggering
    if (loading) return;
    setLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams(window.location.search);
      const id = params.get("id");

      const dataToSend = {
        value: "token",
        id: id,
        leadData: {
          Escalation_Reason: reason,
          Escalation_Remarks: remark,
        },
      };

      console.log("Submitting Escalation...");

      const response = await axios.post(
        "https://lixilpages-60014080522.development.catalystserverless.in/server/feedback_page/createESC_ticket",
        dataToSend,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("API Response:", response.data);

      setSuccessPopup(true);

      setTimeout(() => {
        setReason(ESCALATION_REASONS[0]);
        setRemark("");
        onClose();
      }, 2000);
    } catch (err) {
      console.error("API error:", err);
      setError("Failed to submit escalation. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {successPopup && (
        <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-sm text-center">
            <h2 className="text-green-600 text-lg font-bold mb-3">Success!</h2>
            <p className="text-sm sm:text-base">
              Your Escalation has been submitted successfully!
            </p>
            <button
              onClick={() => {
                setSuccessPopup(false);
                onClose();
              }}
              className="mt-4 bg-green-600 text-white px-4 py-2 rounded text-sm sm:text-base"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/20 p-2 sm:p-4">
        <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-[1200px] max-h-[92vh] overflow-y-auto overflow-x-hidden box-border p-0">
          <button
            className="absolute top-2 right-4 text-[24px] sm:text-[28px] text-[#ff6600] font-bold bg-transparent border-none cursor-pointer z-10"
            onClick={onClose}
          >
            ×
          </button>
          <div className="mb-3 text-[18px] sm:text-[22px] text-[#ff6600] font-bold ml-3 sm:ml-3 mt-7 pr-12">
            Escalation Reason
          </div>
          <div className="px-4 sm:px-8 pb-6 pt-2">
            <div className="mb-4">
              <label className="font-medium block mb-1 text-sm sm:text-base">
                Escalation Reason
              </label>
              <select
                className="w-full mt-1 text-[14px] sm:text-[16px] border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-[#ff6600]"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              >
                {ESCALATION_REASONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="font-medium block mb-1 text-sm sm:text-base">
                Customer Remark
              </label>
              <textarea
                className="w-full text-[14px] sm:text-[16px] border border-gray-300 rounded p-2 mt-1 min-h-[60px] resize-y focus:outline-none focus:ring-2 focus:ring-[#ff6600]"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter your remark"
              />
            </div>
            <div className="flex flex-col sm:flex-row justify-end gap-3 pt-1">
              <button
                type="button"
                className="bg-gray-500 text-white rounded px-4 py-2 text-[14px] sm:text-[15px] w-full sm:w-auto"
                onClick={onClose}
              >
                Close
              </button>
              <button
                type="button"
                className="bg-blue-600 text-white rounded px-4 py-2 text-[14px] sm:text-[15px] w-full sm:w-auto"
                onClick={async () => {
                  await handleSubmit();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/20 p-2 sm:p-4">
      <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-[850px] max-h-[92vh] overflow-auto">
        <button
          onClick={onClose}
          className="absolute top-2 right-4 text-[20px] sm:text-[22px] text-[#ff6600] font-bold bg-transparent border-none cursor-pointer z-10"
          aria-label="Close modal"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}

export default function App() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");

  const [showModal, setShowModal] = useState(false);
  const [showRateCard, setShowRateCard] = useState(false);
  const [showEscalateModal, setShowEscalateModal] = useState(false);
  const [rating, setRating] = useState(null);
  const [reason, setReason] = useState("");
  const [otherText, setOtherText] = useState("");
  const [hoveredBtn, setHoveredBtn] = useState(null);
  const [successPopup, setSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!id) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "20%",
          fontSize: "1.5rem",
          color: "#555",
          fontFamily: "sans-serif",
          padding: "0 20px",
        }}
      >
        No Ticket Id Found
      </div>
    );
  }

  function FeedbackBox() {
    const optionsToShow =
      rating >= 9 ? POSITIVE_FEEDBACK_OPTIONS : NEGATIVE_FEEDBACK_OPTIONS;

    if (rating == null) return null;

    return (
      <form
        className="border border-gray-800 rounded-lg bg-white mt-6 sm:mt-10 mx-2 sm:m-4 p-4 sm:p-6"
        onSubmit={async (e) => {
          e.preventDefault();
          setLoading(true);

          const params = new URLSearchParams(window.location.search);
          const id = params.get("id");

          const apiUrl =
            "https://lixilpages-60014080522.development.catalystserverless.in/server/feedback_page/customer-feedback";

          const zohoGetUrl = `https://www.zohoapis.in/crm/v7/Leads/${id}`;
          const zohoPutUrl = zohoGetUrl;

          try {
            //  STEP 1: Check existing feedback
            const checkResponse = await axios.post(
              apiUrl,
              {
                url: zohoGetUrl,
                method: "GET",
              },
              {
                headers: { "Content-Type": "application/json" },
              }
            );

            const leadData = checkResponse.data?.data?.[0];

            const existingRating =
              leadData?.Sir_Ma_am_How_likely_would_you_like_to_recommend;

            const existingReason = leadData?.NPS_Rating123;

            //  Correct checks
            const hasRating =
              existingRating !== null && existingRating !== "";

            const hasReason =
              Array.isArray(existingReason) && existingReason.length > 0;

            //  Final condition
            if (hasRating || hasReason) {
              alert("Feedback already submitted.");
              setLoading(false);
              return;
            }

            // STEP 2: Submit feedback (PUT)
            const body = {
              data: [
                {
                  NPS_Rating123: ["", reason === "other" ? otherText : reason],
                  NPS_Rating_Validation: "1",
                  NPS_Source: "Portal",
                  Sir_Ma_am_How_likely_would_you_like_to_recommend:
                    rating !== null ? rating.toString() : "",
                },
              ],
            };

            const response = await axios.post(
              apiUrl,
              {
                url: zohoPutUrl,
                method: "PUT",
                body,
              },
              {
                headers: { "Content-Type": "application/json" },
                responseType: "json",
              }
            );

            console.log("response data", response.data);

            if (
              response.data.status === "error" ||
              response.data.details?.code
            ) {
              const errorMsg =
                response.data.details?.message || "Unknown Zoho API error";
              alert(`Zoho API Error: ${errorMsg}`);
              return;
            }

            setSuccessPopup(true);

            setTimeout(() => {
              setSuccessPopup(false);
              setShowModal(false);
              setRating(null);
              setReason("");
              setOtherText("");
            }, 2000);
          } catch (error) {
            if (error.response && error.response.data) {
              const data = error.response.data;
              const errorMsg =
                data.details?.message || data.error || error.message;
              alert(`Error: ${errorMsg}`);
            } else {
              alert(`Unexpected error: ${error.message}`);
            }
            console.error("API call failed:", error);
          } finally {
            setLoading(false);
          }
        }}
      // onSubmit={async (e) => {
      //   e.preventDefault();
      //   setLoading(true);

      //   const params = new URLSearchParams(window.location.search);
      //   const id = params.get("id");

      //   const apiUrl =
      //     "https://lixilpages-60014080522.development.catalystserverless.in/server/feedback_page/customer-feedback";
      //   const zohoApiUrl = `https://www.zohoapis.in/crm/v7/Leads/${id}`;

      //   const method = "PUT";
      //   const body = {
      //     data: [
      //       {
      //         NPS_Rating123: ["", reason === "other" ? otherText : reason],
      //         NPS_Rating_Validation: "1",
      //         NPS_Source: "Portal",
      //         Sir_Ma_am_How_likely_would_you_like_to_recommend:
      //           rating !== null ? rating.toString() : "",
      //       },
      //     ],
      //   };

      //   try {
      //     const response = await axios.post(
      //       apiUrl,
      //       {
      //         url: zohoApiUrl,
      //         method,
      //         body,
      //       },
      //       {
      //         headers: { "Content-Type": "application/json" },
      //         responseType: "json",
      //       }
      //     );

      //     console.log("response data", response.data);

      //     // Handle Zoho API error status in success response
      //     if (
      //       response.data.status === "error" ||
      //       response.data.details?.code
      //     ) {
      //       const errorMsg =
      //         response.data.details?.message || "Unknown Zoho API error";
      //       alert(`Zoho API Error: ${errorMsg}`);
      //       return;
      //     }

      //     // alert(`Update successful for ID: ${id}`);
      //     setSuccessPopup(true);

      //     // Automatically close success dialog after 2 seconds
      //     setTimeout(() => {
      //       setSuccessPopup(false);
      //       setShowModal(false);
      //       setRating(null);
      //       setReason("");
      //       setOtherText("");
      //     }, 2000);
      //   } catch (error) {
      //     // Axios error or network failure
      //     if (error.response && error.response.data) {
      //       // Check if Zoho API error format exists
      //       const data = error.response.data;
      //       const errorMsg =
      //         data.details?.message || data.error || error.message;
      //       alert(`Error: ${errorMsg}`);
      //     } else {
      //       alert(`Unexpected error: ${error.message}`);
      //     }
      //     console.error("API call failed:", error);
      //   } finally {
      //     setLoading(false);
      //   }
      // }}
      >
        {successPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-sm">
              <h2 className="text-green-600 text-base sm:text-lg font-bold mb-3">
                Success!
              </h2>
              <p className="text-sm sm:text-base">
                Your feedback has been submitted successfully.
              </p>
              <button
                onClick={() => setSuccessPopup(false)}
                className="mt-4 bg-green-600 text-white px-4 py-2 rounded text-sm sm:text-base w-full sm:w-auto"
              >
                Close
              </button>
            </div>
          </div>
        )}

        <div className="grid grid-cols-2 gap-x-2 gap-y-6 sm:gap-y-10 mb-6 sm:mb-9 place-items-center">
          {optionsToShow.map((opt) => (
            <label
              key={opt.key}
              className="text-center text-xs sm:text-sm md:text-base font-semibold cursor-pointer"
            >
              <img
                src={opt.img}
                className="w-[60px] h-[60px] sm:w-[90px] sm:h-[90px] mb-2 sm:mb-3 mx-auto"
                alt={opt.label}
              />
              <div>
                <input
                  type="radio"
                  checked={reason === opt.key}
                  onChange={() => {
                    setReason(opt.key);
                    setOtherText("");
                  }}
                  name="reason"
                  className="mb-1"
                />
                <br />
                {opt.label}
              </div>
            </label>
          ))}
        </div>
        <div className="flex items-center gap-2 mt-4 text-sm sm:text-base">
          <input
            type="radio"
            checked={reason === "other"}
            onChange={() => setReason("other")}
            name="reason"
          />
          <span>Others</span>
        </div>
        {reason === "other" && (
          <div>
            <input
              className="mt-4 mb-0 p-2 w-full text-[14px] sm:text-[16px] border border-gray-300 rounded"
              type="text"
              placeholder="Enter Your Remarks"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              required
            />
          </div>
        )}
        <button
          type="submit"
          className="min-w-[98px] bg-[#ff8800] text-white rounded-md px-4 sm:px-6 py-2 mt-4 text-[14px] sm:text-[16px] font-semibold cursor-pointer w-full sm:w-auto"
        >
          Submit
        </button>
      </form>
    );
  }

  const ratingColors = [
    ["0", "#dc2626", "#fff"],
    ["1", "#ea580c", "#fff"],
    ["2", "#f97316", "#fff"],
    ["3", "#fb923c", "#fff"],
    ["4", "#f59e0b", "#fff"],
    ["5", "#eab308", "#fff"],
    ["6", "#facc15", "#fff"],
    ["7", "#fde047", "#fff"],
    ["8", "#bef264", "#fff"],
    ["9", "#84cc16", "#fff"],
    ["10", "#16a34a", "#fff"],
  ];

  return (
    <div className="w-full min-h-screen bg-white px-4 sm:px-6 md:px-10 py-6 sm:py-8 font-sans text-[#212529]">
      <h1 className="text-[22px] sm:text-[28px] font-bold text-[#ff6600] mb-6 sm:mb-8 tracking-tight text-left">
        Feedback Form
      </h1>
      {/* Top Actions - MODIFIED SECTION */}
      {/* <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-4 md:gap-6 justify-start items-stretch sm:items-start mb-8 sm:mb-10">
        {[
          {
            title: "Need details of Repair?",
            btn: "Download Repair Job Sheet",
          },

          { title: "Something Went Wrong?", btn: "Escalate" },
          { title: "Curious About Charges?", btn: "Charges List" },
        ].map((a, i) => (
          <div
            key={i}
            className="flex flex-col items-center w-full sm:min-w-[240px] sm:flex-1 sm:max-w-[350px]"
          >
            <div className="text-[15px] sm:text-[17px] font-bold text-[#232323] text-center mb-3 sm:mb-4">
              {a.title}
            </div>
            <button
              className={`w-full sm:w-[280px] md:w-[320px] lg:w-[350px] border rounded-lg text-[13px] sm:text-[15px] font-semibold py-2.5 sm:py-3 shadow-sm transition

                ${
                  hoveredBtn === i
                    ? "bg-[#ff6600] border-[#ff6600] text-white font-bold"
                    : "bg-[#e8eeff] border-[#d7e2fc] text-[#3563d1]"
                }`}
              onMouseEnter={() => setHoveredBtn(i)}
              onMouseLeave={() => setHoveredBtn(null)}
              onClick={() => {
                if (a.btn === "Charges List") setShowRateCard(true);
                if (a.btn === "Escalate") setShowEscalateModal(true);
              }}
            >
              {a.btn}
            </button>
          </div>
        ))}
      </div> */}
      {/* className="flex flex-col sm:flex-row flex-wrap justify-center */}
      {/* sm:justify-start gap-6 sm:gap-8 lg:gap-10 mb-10 sm:mb-14 px-4" */}
      <div className="sm:flex  sm:justify-between sm:pr-11 pb-6">
        {[
          {
            title: "Need details of Repair?",
            btn: "Download Repair Job Sheet",
          },
          { title: "Something Went Wrong?", btn: "Escalate" },
          { title: "Curious About Charges?", btn: "Charges List" },
        ].map((a, i) => (
          <div
            key={i}
            className="flex flex-col items-center sm:items-start w-full sm:w-[260px] md:w-[300px] lg:w-[340px] text-center sm:text-left"
          >
            <div className="text-[15px] sm:text-[17px] font-semibold text-[#232323] mb-3">
              {a.title}
            </div>

            <button
              className={`w-[80%] border rounded-md text-[14px] sm:text-[15px] font-medium py-2.5 transition
          ${hoveredBtn === i
                  ? "bg-[#ff6600] border-[#ff6600] text-white"
                  : "bg-[#e8eeff] border-[#d7e2fc] text-[#3563d1]"
                }`}
              onMouseEnter={() => setHoveredBtn(i)}
              onMouseLeave={() => setHoveredBtn(null)}
              onClick={() => {
                if (a.btn === "Charges List") setShowRateCard(true);
                if (a.btn === "Escalate") setShowEscalateModal(true);
              }}
            >
              {a.btn}
            </button>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_410px] gap-8 lg:gap-14 items-start">
        {/* Left Section */}
        <div className="w-full max-w-full lg:max-w-[635px]">
          <div className="text-[16px] sm:text-[17px] font-bold text-[#181818] mb-4 sm:mb-6">
            Your Feedback Helps us Serve you Better
          </div>
          <div className="text-[14px] sm:text-[15.6px] text-[#232323] mb-4 leading-relaxed">
            Dear Customer, <br />
            We value your opinion and would love to know what you think about
            our products and services. Would you mind taking a few moments to
            complete our survey? It will help us serve you better in the future.
          </div>

          {/* NPS Section */}
          <div className="mt-8 sm:mt-10">
            <div className="text-[16px] sm:text-[18px] font-bold text-[#111] mb-4 sm:mb-6">
              How likely are you to recommend us to a friend or colleague?
            </div>
            <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-[18px] mb-2 w-full max-w-full">
              {ratingColors.map(([label, bg, color], idx) => (
                <div
                  key={label}
                  className="w-[calc(20%-8px)] min-w-[36px] sm:w-[44px] h-[36px] sm:h-[44px] flex items-center justify-center rounded-md font-bold text-[14px] sm:text-[16.5px] cursor-pointer shadow-sm transition-all"
                  style={{
                    backgroundColor: rating === idx ? "#dc2626" : bg,
                    color: rating === idx ? "#fff" : color,
                  }}
                  onClick={() => {
                    setRating(idx);
                    setReason("");
                    setOtherText("");
                    setShowModal(true);
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.backgroundColor = "#ef4444";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    if (rating !== idx) {
                      e.currentTarget.style.backgroundColor = bg;
                      e.currentTarget.style.color = color;
                    }
                  }}
                >
                  {label}
                </div>
              ))}
            </div>
            <div className="flex justify-between text-gray-500 text-[11px] sm:text-[13px] px-[2px] mt-[6px] w-full max-w-full">
              <span>Less Likely</span>
              <span className="text-center flex-1 mx-2 sm:mx-5 hidden sm:inline">
                Rate in just one click
              </span>
              <span>More Likely</span>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex flex-col items-center sm:items-start text-center sm:text-left mt-6 lg:mt-0 lg:pl-6 w-full">
          <p className="text-[14px] sm:text-[15px] text-[#313235] font-normal mb-4 sm:mb-5 leading-snug max-w-full sm:max-w-[240px]">
            We are now on Best Messaging <br className="hidden sm:inline" />
            Platform to serve you better, <br className="hidden sm:inline" />
            in Real-time!
          </p>
          <a
            href="https://api.whatsapp.com/send/?phone=919821224475&text=Hello&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-[323px] mx-auto sm:mx-0"
          >
            <img
              src={waLogo}
              alt="WhatsApp - Chat with us now!"
              className="w-full max-w-[323px] min-w-[240px] mb-[18px] cursor-pointer transition-shadow duration-300"
              onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(34, 187, 51, 0.16)")
              }
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
            />
          </a>
          <div className="text-[15px] sm:text-[16px] text-[#181818] font-normal leading-tight mb-4 sm:mb-5 ml-0 sm:ml-[6px]">
            +91-9821224475
          </div>
          <img
            src={qrImg}
            alt="WhatsApp QR code"
            className="w-[240px] sm:w-[300px] h-[240px] sm:h-[300px] rounded-lg object-contain mx-auto sm:mx-0"
          />
        </div>
      </div>
      {/* Feedback Modal */}
      {showModal && (
        <Modal
          onClose={() => {
            setShowModal(false);
            setRating(null);
            setReason("");
            setOtherText("");
          }}
        >
          <h2 className="text-[#ff6600] font-bold text-[20px] sm:text-[24px] ml-4 sm:ml-6 mt-5 mb-0 pr-10">
            Thank you for Rating Us!!
          </h2>
          {FeedbackBox()}
        </Modal>
      )}
      {/* Escalate Modal */}
      {showEscalateModal && (
        <EscalateModal onClose={() => setShowEscalateModal(false)} />
      )}
      {/* Charges List Modal */}
      {showRateCard && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/20 p-2 sm:p-4">
          <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-[1100px] max-h-[90vh] overflow-y-auto p-4 sm:p-6 md:p-10 px-4 sm:px-6 md:px-14">
            <button
              onClick={() => setShowRateCard(false)}
              className="absolute top-2 right-3 sm:right-5 text-[20px] sm:text-[22px] text-[#ff6600] font-bold bg-transparent border-none cursor-pointer"
            >
              ×
            </button>
            <h2 className="text-center text-[18px] sm:text-[22px] font-bold my-4 pr-6">
              Standard Labour Charges (Rate Card)
            </h2>
            <div className="overflow-x-auto -mx-2 sm:mx-0">
              <table className="w-full min-w-[600px] border border-gray-400 text-center mb-4 text-xs sm:text-sm md:text-base">
                <thead>
                  <tr className="bg-gray-100">
                    <th rowSpan="2" className="border p-1 sm:p-2 w-[40%]">
                      Description
                    </th>
                    <th colSpan="2" className="border p-1 sm:p-2">
                      Residential
                    </th>
                    <th colSpan="2" className="border p-1 sm:p-2">
                      Commercial
                    </th>
                  </tr>
                  <tr className="bg-gray-100">
                    <th className="border p-1 sm:p-2">Rate (City)</th>
                    <th className="border p-1 sm:p-2">Rate (Upcountry*)</th>
                    <th className="border p-1 sm:p-2">Rate (City)</th>
                    <th className="border p-1 sm:p-2">Rate (Upcountry*)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2 sm:p-3 font-semibold text-left">
                      Service/Labour charges for Out Warranty Cases
                    </td>
                    <td className="border p-2 sm:p-3">350</td>
                    <td className="border p-2 sm:p-3">450</td>
                    <td className="border p-2 sm:p-3">500</td>
                    <td className="border p-2 sm:p-3">600</td>
                  </tr>
                  <tr>
                    <td className="border p-2 sm:p-3 font-semibold text-left">
                      Service/Labour Charges for Inwarranty Chargeable Cases
                      (Warranty Void Cases)
                    </td>
                    <td className="border p-2 sm:p-3">350</td>
                    <td className="border p-2 sm:p-3">450</td>
                    <td className="border p-2 sm:p-3">500</td>
                    <td className="border p-2 sm:p-3">600</td>
                  </tr>
                  <tr>
                    <td className="border p-2 sm:p-3 font-semibold text-left">
                      Service/Labour Charges for Cleaning, Maintenance,
                      Breakdown Calls
                    </td>
                    <td className="border p-2 sm:p-3">350</td>
                    <td className="border p-2 sm:p-3">450</td>
                    <td className="border p-2 sm:p-3">500</td>
                    <td className="border p-2 sm:p-3">600</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-xs sm:text-sm font-semibold mb-2">
              *In case the customer complaint requires Authorized service
              representatives/franchisee to travel beyond the municipal limits
              of the city/town of company's ("Lixil India")
            </p>
            <p className="text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
              Above rates include GST
            </p>
            <h3 className="text-center text-[16px] sm:text-[18px] font-bold mb-3 sm:mb-4">
              Terms & Conditions
            </h3>
            <ol className="list-decimal ml-4 sm:ml-6 space-y-2 text-[13px] sm:text-[15px] leading-relaxed">
              <li>
                There will be a limited period warranty on any repair carried.
                To avail warranty, the customer shall be required to produce an
                E-Warranty registration number **. Warranty terms will be
                applicable at the sole discretion of Lixil India.
              </li>
              <li>
                The customer shall register a service request at the American
                Standard Toll-Free Service number only, and service support will
                be provided between 9 am to 6 pm from Monday to Saturday, except
                public/National Holidays.
              </li>
              <li>
                Above charges will be applicable if the customer is unable to
                produce a valid invoice copy **/ E-Warranty registration number.
              </li>
              <li>
                In void warranty cases, the out-of-warranty service/labour
                charges will be applicable as per above rates.
              </li>
              <li>
                All rates are in INR. Labour/Service charges cover on-site
                visit. Civil work will be charged extra.
              </li>
              <li>
                The company shall be under no obligation to provide
                repair/service because of improper use...
              </li>
              <li>
                While every effort shall be made to give preferential
                attention...
              </li>
              <li>
                Above charges do not include any kind of software support...
              </li>

              <li>
                Lixil India reserves the right to revise the service/labour
                charges...
              </li>
            </ol>
            <p className="text-center font-semibold mt-4 sm:mt-6 text-xs sm:text-sm">
              **T&amp;C apply as per company Warranty Policy (available at the
              company website -{" "}
              <a
                href="https://www.americanstandard.in"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-[#111] break-all"
              >
                www.americanstandard.in
              </a>
              )
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
